var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"breadcrumbs"},[_c('ul',{staticClass:"breadcrumbs__list"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),(_vm.$route.name !== 'Exames')?_c('li',[_c('span',[_vm._v(_vm._s(_vm.lastLinkText))])]):_vm._e()])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('li',[_c('a',{attrs:{"href":"https://alvaroapoio.com.br/"}},[_vm._v("Home")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('li',[_c('a',{attrs:{"href":"/exames"}},[_vm._v("Guia de Exames")])])
}]
render._withStripped = true
export { render, staticRenderFns }